export type PropertyDataForAnalytics = {
    uprn?: string | null;
    numberBeds?: number | null;
    numberBaths?: number | null;
    postcode?: string;
    priceEstimate?: number | null;
    rentalEstimate?: number | null;
    propertyAddress?: string;
    listingId?: string;
    displayAddress?: string | null;
    price?: number | null;
    rent?: number | null;
    numBeds?: number | null;
};

interface Property {
    address?: Address | null;
    attributes?: Attributes | null;
    saleEstimate?: Estimate | null;
    rentEstimate?: Estimate | null;
    liveListings?: LiveListing[] | null;
    uprn?: string | null;
}

interface Estimate {
    currentPrice: number;
}

interface Address {
    fullAddress: string;
    postcode: string;
}

type Attributes = {
    bathrooms?: number | null;
    bedrooms?: number | null;
};

type LiveListing = {
    displayAddress?: string | null;
    listingId: string;
    price?: number | null;
    rentPerMonth?: number | null;
    totalBedrooms?: number | null;
};

export const getPropertyDataForAnalytics = (
    property?: Property
): PropertyDataForAnalytics => {
    const {
        address,
        attributes,
        saleEstimate,
        rentEstimate,
        liveListings,
        uprn
    } = property || {};

    return {
        uprn: uprn,
        numberBeds: attributes?.bedrooms,
        numberBaths: attributes?.bathrooms,
        postcode: address?.postcode,
        priceEstimate: saleEstimate?.currentPrice,
        rentalEstimate: rentEstimate?.currentPrice,
        propertyAddress: address?.fullAddress,
        listingId: liveListings?.[0]?.listingId,
        displayAddress: liveListings?.[0]?.displayAddress,
        price: liveListings?.[0]?.price,
        rent: liveListings?.[0]?.rentPerMonth,
        numBeds: liveListings?.[0]?.totalBedrooms
    };
};
